export class CustomersHttp {
    /**
     * Find Customers
     * @param q
     * @returns {Promise<void>}
     */
    static async findCustomers(q) {
        try {
            return await window.axios.get(`customer/find?q=${q}`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Get all customers
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async getAllCustomers() {
        try {
            return await window.axios.get(`customer`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Create a new customer
     * @param customer
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async createNewCustomer(customer) {
        try {
            return await window.axios.post(`customer`, customer);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Update a customer
     * @param id
     * @param customer
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async updateCustomer(id, customer) {
        try {
            return await window.axios.put(`customer/${id}`, customer);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Delete a customer
     * @param id
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async deleteCustomer(id) {
        try {
            return await window.axios.delete(`customer/${id}`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }
}
